var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.popup.component
    ? _c(
        "modal",
        {
          staticClass: "modal-identify-viewer",
          class: _vm.className,
          attrs: {
            show: _vm.popup.show,
            title: _vm.popup.title,
            needFooter: false,
            centered: true,
            size: "large",
            bodyClass: "overflowY",
          },
          on: { close: _vm.onClosePopup },
        },
        [
          _vm.displayPrint && !_vm.startedProcess
            ? _c("template", { slot: "modal-header-actions" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0",
                    attrs: {
                      type: "button",
                      title: "Imprimir",
                      "data-dismiss": "modal",
                      "aria-label": "Print",
                    },
                    on: { click: _vm.onPrint },
                  },
                  [_c("i", { staticClass: "fas fa-print" })]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-column flex-fill h-100",
              class: [
                (_vm.displayPrint && !_vm.startedProcess) || !_vm.displayPrint
                  ? "d-flex"
                  : "d-none",
              ],
            },
            [
              _c(_vm.popup.component, {
                tag: "component",
                staticClass: "overflowHiddenX",
                attrs: { url: _vm.popup.url, useProxy: false },
                on: { error: _vm.onInfoError },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.displayPrint
            ? _c(
                "div",
                {
                  staticClass: "panel-control flex-column flex-fill h-100",
                  class: [_vm.startedProcess ? "d-flex" : "d-none"],
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-control-content d-flex flex-column flex-fill",
                    },
                    [
                      _vm.startedProcess
                        ? _c("print-process-workflow", {
                            attrs: {
                              description: _vm.printDescription,
                              titleList: _vm.printTitleList,
                              emptyResult: _vm.printEmptyResult,
                              url: _vm.print.url.status,
                              id: _vm.idProcess,
                              canceled: _vm.print.canceled,
                              showBtnClose: _vm.print.showBtnClose,
                              titleBtnClose: _vm.print.titleBtnClose,
                            },
                            on: { close: _vm.onClosePrint },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }